import { render, staticRenderFns } from "./TeacherInfo.vue?vue&type=template&id=793921fe&"
import script from "./TeacherInfo.vue?vue&type=script&lang=js&"
export * from "./TeacherInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports